import React, { useEffect, useState } from 'react';
import Slider from '../../../../../components/utils/Slider/Slider';
import Modal from '../../../../../components/Modal';
import Img from '../../../../../components/Img';
import BaseForm from '../../../../../components/form/BaseForm';
import DateSinglePicker from '../../../../../components/datePicker/DateSinglePicker';
import moment, { setDateFormat } from '../../../../../lib/moment';
import { checkIsBetween } from '../../../../../lib/common';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import './PreviewExposureEventModal.scss';

const EventPreviewWrap = (props) => {
  const { list } = props;
  return (
    <div className="event-preview-wrap">
      <Slider
        emptyText="위젯에 노출중인 기획전이 없습니다."
        list={list}
        arrows={false}
        infinite={false}
        item={(item) => (
          <div className="event-image">
            <Img clickAble={false} src={item.url} />
          </div>
        )}
      />
    </div>
  );
};

const PreviewExposureEventModal = (props) => {
  const { isOpen, closeModal, exposureEventList } = props;
  const [exposureDate, setExposureDate] = useState(setDateFormat(moment(), DATE_FORMAT.FULL_DASH_FORMAT));
  const [currentTimeEventList, setCurrentTimeEventList] = useState(exposureEventList);
  const [settingTimeEventList, setSettingTimeEventList] = useState([]);

  useEffect(() => {
    // 현재 시점에서 노출되는 기획전 리스트
    setCurrentTimeEventList(
      exposureEventList.filter((event) =>
        checkIsBetween(DATE_FORMAT.FULL_DASH_FORMAT, event.exposurePeriod.startDate, event.exposurePeriod.endDate),
      ),
    );
  }, [exposureEventList]);

  useEffect(() => {
    // 특정 시점에서 노출되는 기획전 리스트
    setSettingTimeEventList(
      exposureEventList.filter((event) =>
        checkIsBetween(
          DATE_FORMAT.FULL_DASH_FORMAT,
          event.exposurePeriod.startDate,
          event.exposurePeriod.endDate,
          exposureDate,
        ),
      ),
    );
  }, [exposureDate, exposureEventList]);

  return (
    <Modal
      title="기획전 미리보기"
      isOpen={isOpen}
      width={870}
      height={650}
      isFooter={true}
      overflow="hidden"
      onOk={() => closeModal()}
      onClose={() => closeModal()}
    >
      <div className="preview-exposure-event-modal">
        <BaseForm
          className="exposure-period"
          label="노출 설정 시점"
          content={
            <DateSinglePicker
              value={exposureDate}
              showTime={true}
              outFormat={DATE_FORMAT.FULL_DASH_FORMAT}
              btnTextFormat={DATE_FORMAT.FULL_DASH_FORMAT}
              format={DATE_FORMAT.FULL_DASH_FORMAT}
              onSelect={setExposureDate}
            />
          }
        />

        <div className="preview-area">
          <div className="before">
            <div className="title">현재 시점 노출</div>

            <EventPreviewWrap list={currentTimeEventList} />
          </div>

          <div className="after">
            <div className="title">설정된 시점 노출</div>

            <EventPreviewWrap list={settingTimeEventList} />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PreviewExposureEventModal;
